<template>
    <div class="payable_statistics_wrap" v-loading="loading">
        <el-tabs v-model="tabActiveName" @tab-click="handleClickTab">
            <el-tab-pane v-for="item in tabList" :label="item.label" :name="item.name" :key="item.name"> </el-tab-pane>
        </el-tabs>
        <div class="content_right_wrap">
            <div class="page-filter_wrap">
                <div class="page-filter_wrap_left">
                    <el-input
                        v-model="searchForm.keyword"
                        class="filter-input"
                        clearable
                        placeholder="请输入您想搜索的内容"
                        @clear="handleClickSearch"
                        @keyup.enter.native="handleClickSearch"
                    >
                        <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                    </el-input>
                    <!-- <el-select v-model="searchForm.dateType" placeholder="请选择" size="small" @change="handleClickDateChange">
                        <el-option label="本月" value="month"></el-option>
                        <el-option label="本季度" value="quarter"></el-option>
                        <el-option label="本年" value="year"></el-option>
                        <el-popover placement="bottom" ref="customDatePopover" trigger="click" width="375">
                            <el-option label="自定义日期" value="customDate" slot="reference"></el-option>
                            <el-date-picker
                                v-model="searchForm.customDate"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                range-separator="-"
                                size="small"
                                start-placeholder="开始日期"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                @change="handleCustomDateChange"
                            >
                            </el-date-picker>
                        </el-popover>
                    </el-select> -->
                    <el-date-picker
                        v-if="tabActiveName !== 'unRefund'"
                        :picker-options="pickerOptions"
                        @change="handleClickSearch"
                        align="right"
                        size="small"
                        end-placeholder="结束日期"
                        format="yyyy-MM-dd"
                        range-separator="-"
                        start-placeholder="开始日期"
                        type="daterange"
                        unlink-panels
                        v-model="searchForm.date_range"
                        value-format="yyyy-MM-dd"
                        :clearable="false"
                    >
                    </el-date-picker>
                </div>
            </div>
            <div class="page-content">
                <ul class="static_num_top" v-if="tabActiveName == 'receivableSummary'">
                    <li>
                        <p>应收待确认汇总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.pending_confirmation_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                    <li>
                        <p>应收已确认汇总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.confirmed_confirmation_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                    <li>
                        <p>应收已驳回汇总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.rejected_confirmation_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                </ul>
                <ul class="static_num_top" v-else-if="tabActiveName == 'purchase'">
                    <li>
                        <p>采购退款待确认总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.pending_confirmation_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                    <li>
                        <p>采购退款已确认总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.confirmed_confirmation_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                </ul>
                <ul class="static_num_top" v-else-if="tabActiveName == 'orderRefund'">
                    <li>
                        <p>订单回款待确认总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.pending_confirmation_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                    <li>
                        <p>订单回款已确认总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.confirmed_confirmation_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                    <li>
                        <p>订单回款已驳回总金额</p>
                        <p>
                            {{
                                Number(
                                    summaryData.summary_data && summaryData.summary_data.rejected_confirmation_amount
                                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}元
                        </p>
                    </li>
                </ul>
                <ul class="static_num_top" v-else-if="tabActiveName == 'unRefund'">
                    <li>
                        <p>未回款总金额</p>
                        <p>
                            {{
                                Number(summaryData.total_unpaid_amount).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })
                            }}元
                        </p>
                    </li>
                </ul>
                <ul class="static_num_top" v-else>
                    <li>
                        <p>坏账总金额</p>
                        <p>
                            {{
                                Number(summaryData.total_bad_debt_amount).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })
                            }}元
                        </p>
                    </li>
                </ul>
                <div class="chart_box">
                    <div class="chart_item_box chart_item_box_bar">
                        <div class="chart_box_title">
                            <span>{{ tabList.find((item) => item.name === tabActiveName).chartTitle }}</span>
                            <div class="chart_box_title_right">
                                <span
                                    v-for="item in chartDateTypeList"
                                    :key="item.type"
                                    :class="{ active: chartDateType === item.type }"
                                    @click="handleClickChartType(item.type)"
                                    >{{ item.name }}</span
                                >
                            </div>
                        </div>
                        <div class="chart_box_bottom">
                            <div class="echarts_container" id="container1"></div>
                        </div>
                    </div>
                    <!-- <div class="chart_item_box chart_item_box_pie">
                        <div class="chart_box_title">
                            <span>各业务应付总金额占比</span>
                        </div>
                        <div class="chart_box_bottom">
                            <div class="echarts_container" id="container2"></div>
                        </div>
                    </div> -->
                </div>
                <el-table
                    :data="summaryData.list_data"
                    size="small"
                    border
                    ref="payableStatisticsTable"
                    class="custom_table"
                >
                    <template v-if="tabActiveName == 'receivableSummary'">
                        <el-table-column
                            label="回款公司名称/供应商名称"
                            min-width="380"
                            prop="payable_num1"
                            show-overflow-tooltip
                            key="1"
                        >
                            <template slot-scope="{ row }">
                                <span>{{ row.customer_name || row.supplier_name }}</span>
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else-if="tabActiveName === 'orderRefund'">
                        <el-table-column
                            label="回款公司名称"
                            min-width="380"
                            prop="payable_num4"
                            show-overflow-tooltip
                            key="4"
                        >
                            <template slot-scope="{ row }">
                                <span>{{ row.payment_company_name }}</span>
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else-if="tabActiveName === 'purchase'">
                        <el-table-column
                            label="供应商名称"
                            min-width="380"
                            prop="supplier_name"
                            show-overflow-tooltip
                            key="2"
                        >
                            <template slot-scope="{ row }">
                                <span>{{ row.supplier_name }}</span>
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else>
                        <el-table-column
                            label="客户公司名称"
                            min-width="380"
                            prop="customer_name"
                            show-overflow-tooltip
                            key="3"
                        >
                            <template slot-scope="{ row }">
                                <span
                                    class="link-label"
                                    @click="handleClickCustomerDetail(row.customer_id, row.customer_name)"
                                    >{{ row.customer_name }}</span
                                >
                            </template>
                        </el-table-column>
                    </template>
                    <template v-if="tabActiveName == 'badDebt'">
                        <el-table-column
                            align="right"
                            label="坏账总金额"
                            min-width="210"
                            prop="total_bad_debt_amount"
                            show-overflow-tooltip
                            key="8"
                        >
                            <template slot-scope="{ row }">
                                <span
                                    v-text="
                                        Number(row.total_bad_debt_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    "
                                ></span>
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else-if="tabActiveName == 'unRefund'">
                        <el-table-column
                            align="right"
                            label="未回款总金额"
                            min-width="210"
                            prop="total_unpaid_amount"
                            show-overflow-tooltip
                            key="8"
                        >
                            <template slot-scope="{ row }">
                                <span
                                    v-text="
                                        Number(row.total_unpaid_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    "
                                ></span>
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else>
                        <el-table-column
                            align="right"
                            label="待确认总金额"
                            min-width="210"
                            prop="payable_num"
                            show-overflow-tooltip
                            key="5"
                        >
                            <template slot-scope="{ row }">
                                <span
                                    v-text="
                                        Number(row.pending_confirmation_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    "
                                ></span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="right"
                            label="已确认总金额"
                            min-width="210"
                            prop="payable_num"
                            show-overflow-tooltip
                            key="6"
                        >
                            <template slot-scope="{ row }">
                                <span
                                    v-text="
                                        Number(row.confirmed_confirmation_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    "
                                ></span>
                            </template>
                        </el-table-column>
                        <template v-if="tabActiveName == 'receivableSummary' || tabActiveName === 'orderRefund'">
                            <el-table-column
                                align="right"
                                label="已驳回总金额"
                                min-width="210"
                                prop="payable_num"
                                show-overflow-tooltip
                                key="7"
                            >
                                <template slot-scope="{ row }">
                                    <span
                                        v-text="
                                            Number(row.rejected_confirmation_amount).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        "
                                    ></span>
                                </template>
                            </el-table-column>
                        </template>
                    </template>
                    <el-table-column fixed="right" align="right" label="操作" min-width="90">
                        <template slot-scope="{ row }">
                            <el-link :underline="false" @click="handleClickDetail(row)" type="primary" v-text="'明细'">
                            </el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-dialog
                title="明细"
                :visible.sync="detailDialogVisible"
                :width="getDetailDialogWidth"
                :before-close="handleDialogClose"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :modal-append-to-body="false"
                class="custom_form_dialog custom-form-dialog"
            >
                <div class="custom_form_body">
                    <template v-if="tabActiveName == 'unRefund' || tabActiveName == 'badDebt'">
                        <el-table :data="detailTableData" size="small" border class="custom_table">
                            <template>
                                <el-table-column
                                    label="客户公司名称"
                                    min-width="164"
                                    prop="customer_name"
                                    show-overflow-tooltip
                                    key="1"
                                >
                                    <template slot-scope="{ row }">
                                        <template v-if="tabActiveName == 'unRefund'">
                                            <span
                                                class="link-label"
                                                @click="handleClickCustomerDetail(customer_id, row.customer_name)"
                                                >{{ row.customer_name }}</span
                                            >
                                        </template>
                                        <template v-else>
                                            <span
                                                class="link-label"
                                                @click="
                                                    handleClickCustomerDetail(
                                                        row.customer_info && row.customer_info.id,
                                                        row.customer_info && row.customer_info.name
                                                    )
                                                "
                                                >{{ row.customer_info && row.customer_info.name }}</span
                                            >
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="订单编号"
                                    min-width="142"
                                    prop="order_num"
                                    show-overflow-tooltip
                                    key="2"
                                >
                                    <template slot-scope="{ row }">
                                        <span class="link-label" @click="handleClickOrderDetail(row)">{{
                                            row.order_num
                                        }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    align="right"
                                    label="订单总金额"
                                    min-width="118"
                                    prop="total_price"
                                    show-overflow-tooltip
                                    key="3"
                                >
                                    <template slot-scope="{ row }">
                                        <span
                                            v-text="
                                                Number(row.total_price).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })
                                            "
                                        ></span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    align="right"
                                    label="已回款总金额"
                                    min-width="112"
                                    prop="total_repay_price"
                                    show-overflow-tooltip
                                    key="4"
                                >
                                    <template slot-scope="{ row }">
                                        <span
                                            v-text="
                                                Number(row.total_repay_price).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })
                                            "
                                        ></span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    align="right"
                                    label="未回款金额"
                                    min-width="108"
                                    prop="no_repay_price"
                                    show-overflow-tooltip
                                    key="5"
                                >
                                    <template slot-scope="{ row }">
                                        <span
                                            v-text="
                                                Number(row.no_repay_price).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })
                                            "
                                        ></span>
                                    </template>
                                </el-table-column>
                                <template v-if="tabActiveName == 'badDebt'">
                                    <el-table-column
                                        align="right"
                                        label="坏账金额"
                                        min-width="106"
                                        prop="bad_debt_amount"
                                        show-overflow-tooltip
                                        key="6"
                                    >
                                        <template slot-scope="{ row }">
                                            <span
                                                v-text="
                                                    Number(row.bad_debt_amount).toLocaleString(undefined, {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })
                                                "
                                            ></span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </template>
                        </el-table>
                    </template>
                    <template
                        v-else-if="
                            tabActiveName == 'orderRefund' || (tabActiveName == 'receivableSummary' && customer_id)
                        "
                    >
                        <el-table :data="detailTableData" size="small" border class="custom_table">
                            <el-table-column
                                label="回款编号"
                                min-width="142"
                                prop="receivable_no"
                                show-overflow-tooltip
                                key="7"
                            >
                                <template slot-scope="{ row }">
                                    <span class="link-label" @click="handleClickReceivableDetail(row)">{{
                                        row.receivable_no
                                    }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="客户公司名称"
                                min-width="164"
                                prop="customer_name"
                                show-overflow-tooltip
                                key="8"
                            >
                                <template slot-scope="{ row }">
                                    <span
                                        class="link-label"
                                        @click="
                                            handleClickCustomerDetail(
                                                row.customer_info && row.customer_info.id,
                                                row.customer_name
                                            )
                                        "
                                        >{{ row.customer_name }}</span
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="回款公司名称"
                                min-width="164"
                                prop="payment_company_name"
                                show-overflow-tooltip
                                key="9"
                            >
                                <template slot-scope="{ row }">
                                    <span>{{ row.payment_company_name }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="订单编号"
                                min-width="142"
                                prop="order_num"
                                show-overflow-tooltip
                                key="10"
                            >
                                <template slot-scope="{ row }">
                                    <span class="link-label" @click="handleClickOrderDetail(row)">{{
                                        row.order_num
                                    }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="申请人"
                                min-width="150"
                                prop="application_name"
                                show-overflow-tooltip
                                key="11"
                            >
                                <template slot-scope="{ row }">
                                    <PersonnelCard :userId="row.uid_info.id" v-if="row.uid_info && row.uid_info.id">
                                        <template slot="container">
                                            <div class="user-avatar-btn">
                                                <img
                                                    :src="row.uid_info.avatar ? row.uid_info.avatar : defaultImg"
                                                    alt=""
                                                />
                                                <span>{{ row.uid_info.name }}</span>
                                            </div>
                                        </template>
                                    </PersonnelCard>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="right"
                                label="待确认金额"
                                min-width="114"
                                prop="receivable_amount"
                                show-overflow-tooltip
                                key="12"
                            >
                                <template slot-scope="{ row }">
                                    <span
                                        v-text="
                                            Number(
                                                row.status == 1 ? row.receivable_amount : row.confirmed_amount
                                            ).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        "
                                    ></span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="right"
                                label="已确认金额"
                                min-width="108"
                                prop="confirmed_amount"
                                show-overflow-tooltip
                                key="13"
                            >
                                <template slot-scope="{ row }">
                                    <span
                                        v-text="
                                            Number(row.confirmed_amount).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        "
                                    ></span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="right"
                                label="已驳回金额"
                                min-width="108"
                                prop="rejected_amount"
                                show-overflow-tooltip
                                key="14"
                            >
                                <template slot-scope="{ row }">
                                    <span
                                        v-text="
                                            Number(row.rejected_amount).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        "
                                    ></span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                    <template
                        v-else-if="
                            tabActiveName == 'purchase' || (tabActiveName == 'receivableSummary' && !customer_id)
                        "
                    >
                        <el-table :data="detailTableData" size="small" border class="custom_table">
                            <el-table-column
                                label="应收编号"
                                min-width="164"
                                prop="receivable_no"
                                show-overflow-tooltip
                                key="15"
                            >
                                <template slot-scope="{ row }">
                                    <span class="link-label" @click="handleClickReceivableDetail(row)">{{
                                        row.receivable_no
                                    }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="供应商名称"
                                min-width="164"
                                prop="supplier_name"
                                show-overflow-tooltip
                                key="16"
                            >
                                <template slot-scope="{ row }">
                                    <span>{{ row.supplier_name }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="采购编号"
                                min-width="142"
                                prop="purchase_refund_no"
                                show-overflow-tooltip
                                key="17"
                            >
                                <template slot-scope="{ row }">
                                    <span class="link-label" @click="handleClickRelateId(row.purchase_id)">{{
                                        row.purchase_refund_no
                                    }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="审批编号"
                                min-width="102"
                                prop="approval_id"
                                show-overflow-tooltip
                                key="18"
                            >
                                <template slot-scope="{ row }">
                                    <span class="link-label" @click="handleClickApprovalDetail(row.approval_id)">{{
                                        row.approval_id
                                    }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="申请人"
                                min-width="150"
                                prop="application_name"
                                show-overflow-tooltip
                                key="19"
                            >
                                <template slot-scope="{ row }">
                                    <PersonnelCard :userId="row.uid_info.id" v-if="row.uid_info && row.uid_info.id">
                                        <template slot="container">
                                            <div class="user-avatar-btn">
                                                <img
                                                    :src="row.uid_info.avatar ? row.uid_info.avatar : defaultImg"
                                                    alt=""
                                                />
                                                <span>{{ row.uid_info.name }}</span>
                                            </div>
                                        </template>
                                    </PersonnelCard>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="right"
                                label="待确认金额"
                                min-width="114"
                                prop="receivable_amount"
                                show-overflow-tooltip
                                key="20"
                            >
                                <template slot-scope="{ row }">
                                    <span
                                        v-text="
                                            Number(
                                                row.status == 1 ? row.receivable_amount : row.confirmed_amount
                                            ).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        "
                                    ></span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="right"
                                label="已确认金额"
                                min-width="108"
                                prop="confirmed_amount"
                                show-overflow-tooltip
                                key="21"
                            >
                                <template slot-scope="{ row }">
                                    <span
                                        v-text="
                                            Number(row.confirmed_amount).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        "
                                    ></span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                </div>
            </el-dialog>
            <ReceivableDetails
                v-if="receivableDetailsVisible"
                :receivableDetailsVisible.sync="receivableDetailsVisible"
                :receivable_no="receivable_no"
            />
            <PurchaseDetail
                :purchaseDetailVisible.sync="purchaseDetailVisible"
                v-if="purchaseDetailVisible"
                :purchaseId="purchaseId"
            />
        </div>
    </div>
</template>
<script>
import * as echarts from "echarts";
import {
    BadDebtSummary,
    BadDebtCustomerDetail,
    UnpaidSummary,
    UnpaidCustomerOrders,
    OrderRepaySummary,
    RepayCompanyDetail,
    PurchaseRefundSummary,
    PurchaseRefundDetailList,
    ReceivableSummary,
    ReceivableOrderSummaryDetail,
    ReceivablePurchaseRefundSummaryDetail,
} from "@/api";
import { getDateRange, formatDate } from "@/utils";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
import ReceivableDetails from "./component/receivable_details.vue";
import PurchaseDetail from "../../Purchase/component/purchase_detail.vue";
export default {
    name: "ReceivableStatistics",
    components: { PersonnelCard, ReceivableDetails, PurchaseDetail },
    data() {
        let that = this;
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            loading: false,
            tabActiveName: "receivableSummary",
            tabList: [
                { name: "receivableSummary", label: "应收汇总统计", chartTitle: "应收待确认汇总金额统计" },
                { name: "orderRefund", label: "订单回款应收统计", chartTitle: "订单回款应收统计" },
                { name: "purchase", label: "采购退款应收统计", chartTitle: "采购退款待确认总金额统计" },
                { name: "unRefund", label: "未回款统计", chartTitle: "未回款总金额统计" },
                { name: "badDebt", label: "坏账款项统计", chartTitle: "坏账总金额统计" },
            ],
            searchForm: {
                keyword: "",
                date_range: "",
                dateType: "month",
                customDate: "",
                date: "",
            },
            dateTypeList: [
                { value: "month", label: "本月" },
                { value: "quarter", label: "本季度" },
                { value: "year", label: "本年" },
                { value: "customDate", label: "自定义日期" },
            ],
            chartDateType: "day",
            chartDateTypeList: [
                { name: "日", type: "day" },
                { name: "周", type: "week" },
                { name: "月", type: "month" },
            ],
            pickerOptions: {
                shortcuts: [
                    {
                        text: "本月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date(end.getFullYear(), end.getMonth(), 1);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "本季度",
                        onClick(picker) {
                            const start = new Date();
                            start.setMonth(Math.floor(start.getMonth() / 3) * 3, 1);
                            start.setHours(0, 0, 0, 0);

                            const end = new Date(start);
                            end.setMonth(start.getMonth() + 3, 0);
                            end.setHours(23, 59, 59, 999);

                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "本年",
                        onClick(picker) {
                            const start = new Date(new Date().getFullYear(), 0, 1);
                            start.setHours(0, 0, 0, 0);

                            const end = new Date(new Date().getFullYear(), 11, 31);
                            end.setHours(23, 59, 59, 999);

                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
                //限制只能选择一年时间
                disabledDate(time) {
                    if (!that.searchForm.date_range || that.searchForm.date_range[0] == null) return false;

                    let chosedDate = new Date(that.searchForm.date_range[0]);
                    let startyear = chosedDate.getFullYear() - 1;
                    let endYear = chosedDate.getFullYear() + 1;
                    let endDate = endYear + "-" + (chosedDate.getMonth() + 1) + "-" + chosedDate.getDate();
                    let startDate = startyear + "-" + (chosedDate.getMonth() + 1) + "-" + chosedDate.getDate();
                    let _endDate = new Date(endDate);
                    let _startDate = new Date(startDate);
                    //即大于开始时间小于结束时间
                    return time.getTime() > _endDate.getTime() || time.getTime() < _startDate.getTime();
                },
                onPick({ maxDate, minDate }) {
                    //重新设置开始时间
                    if (!minDate) {
                        minDate = new Date();
                    }
                    that.searchForm.date_range = [minDate];
                },
            },
            // 统计数据
            summaryData: {
                total_unpaid_amount: 0, // 未回款总金额
                total_bad_debt_amount: 0, // 坏账总金额
                summary_data: {
                    total_unpaid_amount: 0,
                    pending_confirmation_amount: 0,
                    confirmed_confirmation_amount: 0,
                    rejected_confirmation_amount: 0,
                },
                trend_data: [], // 图表数据
                list_data: [], // 表格数据
            },
            // 明细弹框
            customer_id: "",
            payment_company_name: "",
            supplier_name: "",
            detailDialogVisible: false,
            detailTableData: [],
            // 应收详情
            receivableDetailsVisible: false,
            receivable_no: "",

            // 采购详情
            purchaseDetailVisible: false,
            purchaseId: "",
        };
    },
    computed: {
        getDetailDialogWidth() {
            const tabActiveName = this.tabActiveName;
            if (tabActiveName == "badDebt") {
                return "800px";
            } else if (tabActiveName == "unRefund") {
                return "694px";
            } else if (
                this.tabActiveName == "orderRefund" ||
                this.tabActiveName == "purchase" ||
                this.tabActiveName == "receivableSummary"
            ) {
                return "1110px";
            }
        },
    },
    created() {
        const end = new Date();
        const start = new Date(end.getFullYear(), end.getMonth(), 1);
        this.searchForm.date_range = [formatDate(start, "date"), formatDate(end, "date")];
        this.handleClickSearch();
    },
    mounted() {},
    methods: {
        handleClickTab() {
            this.$nextTick(() => {
                this.$refs.payableStatisticsTable.doLayout();
                this.handleClickSearch();
            });
        },
        // 时间筛选
        handleClickDateChange(value) {
            if (value == "month" || value == "year") {
                this.searchForm.date = getDateRange(value);
            }
        },
        // 选择自定义时间
        handleCustomDateChange(val) {
            if (val && val.length) {
                this.$refs.customDatePopover.doClose();
            }
        },
        handleClickSearch() {
            if (
                !this.searchForm.date_range ||
                (this.searchForm.date_range && (!this.searchForm.date_range[0] || !this.searchForm.date_range[1]))
            ) {
                const end = new Date();
                const start = new Date(end.getFullYear(), end.getMonth(), 1);
                this.searchForm.date_range = [formatDate(start, "date"), formatDate(end, "date")];
            }
            if (this.tabActiveName == "badDebt") {
                this.getBadDebtSummary();
            } else if (this.tabActiveName == "unRefund") {
                this.getUnpaidSummary();
            } else if (this.tabActiveName == "orderRefund") {
                this.getOrderRepaySummary();
            } else if (this.tabActiveName == "purchase") {
                this.getPurchaseRefundSummary();
            } else {
                this.getReceivableSummary();
            }
        },
        // 图表日期类型切换
        handleClickChartType(type) {
            this.chartDateType = type;
            this.$nextTick(() => {
                this.handleClickSearch();
            });
        },
        // 坏账统计数据
        getBadDebtSummary() {
            const params = {
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
                chart_time_type: this.chartDateType,
            };
            BadDebtSummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, "坏账总金额");
                }
            });
        },
        // 未回款统计
        getUnpaidSummary() {
            const params = {
                keyword: this.searchForm.keyword,
                // date_range: this.searchForm.date_range,
                chart_time_type: this.chartDateType,
            };
            UnpaidSummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, "未回款总金额");
                }
            });
        },
        // 订单回款应收统计
        getOrderRepaySummary() {
            const params = {
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
                chart_time_type: this.chartDateType,
            };
            OrderRepaySummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, "订单回款待确认总金额");
                }
            });
        },
        // 采购退款应收统计
        getPurchaseRefundSummary() {
            const params = {
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
                chart_time_type: this.chartDateType,
            };
            PurchaseRefundSummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, "采购退款待确认总金额");
                }
            });
        },
        // 应收汇总
        getReceivableSummary() {
            const params = {
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
                chart_time_type: this.chartDateType,
            };
            ReceivableSummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, "应收待确认汇总金额统计");
                }
            });
        },
        getBarData(data, tooltipName) {
            let xData = data.map((item) => item.operate_date);
            let sData = data.map((item) => item.total_amount);

            var charts = document.getElementById("container1");
            var myChart = echarts.getInstanceByDom(charts);
            if (myChart) {
                myChart.dispose();
            }
            this.getEchartsBar("container1", xData, sData, tooltipName);
        },
        getEchartsBar(id, xData, sData, tooltipName) {
            var dom = document.getElementById(id);
            this.myChartBar = echarts.init(dom);
            this.myChartBar.clear();
            var color = ["#1890ff", "#52C41B", "#FBAD13", "#FF4D4F", "#00BAAD"];
            var option;
            option = {
                color,
                grid: {
                    left: "10px",
                    top: "10px",
                    right: "0%",
                    bottom: "16px",
                    containLabel: true,
                },
                tooltip: {
                    trigger: "item",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                    },
                    triggerOn: "mousemove", // 鼠标移动时触发 tooltip
                    enterable: true,
                    zIndex: 1000, // 提高 tooltip 的层级
                    backgroundColor: "#fffffff",
                    padding: 12,
                    // position: function (point, params, dom, rect, size) {
                    //     return [  point[0], point[1]];
                    // },
                    formatter: function (params) {
                        let html = `<div class="custom_chart_tooltip"><p class="tooltip_title">${
                            params.name
                        }</p><p class="tooltip_content"><span>${tooltipName}</span><span class="count">${
                            params.data + "元"
                        }</span></p></div>`;
                        return html;
                    },
                },
                xAxis: {
                    type: "category",
                    data: xData,
                    axisLabel: {
                        interval: 0,
                        rotate: 0,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        color: "#000000FF",
                    },
                },
                yAxis: {
                    type: "value",
                    name: "", // 设置 y 轴标题
                    min: 0, // 设置最小值
                    scale: true, // 允许动态缩放
                    axisLine: {
                        show: false,
                    },
                    splitLine: {},
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        color: "rgba(0,0,0,.45)",
                    },
                },
                series: [
                    {
                        data: sData,
                        type: "bar",
                    },
                ],
            };
            if (option && typeof option === "object") {
                this.myChartBar.setOption(option, true);
            }
            this.handleResize();
            window.addEventListener("resize", this.handleResize);
        },
        getPieData() {
            let list = [
                { type_title: "订单退款应付总金额", total_num: "498.8", rate: 37 },
                { type_title: "应付控件组名称应付总金额", total_num: "700", rate: 49 },
                { type_title: "应付控件名称应付总金额", total_num: "12.0", rate: 12 },
                { type_title: "采购应付总金额", total_num: "39.8", rate: 13 },
            ];
            let sData = [];
            let sData2 = [];
            const color = [
                "#2990FF",
                "#F0AA32",
                "#5AB333",
                "#16ABA1",
                "#2E7DD9",
                "#9ECF36",
                "#DEAC07",
                "#E44144",
                "#A522BD",
                "#7143DE",
            ];
            list.forEach((item, index) => {
                const s_item = {
                    name: item.type_title,
                    value: item.total_num,
                    color: color[index],
                    rate: item.rate,
                    label: {
                        // alignTo: "edge",
                        position: "outside",
                        formatter: `{circle|c}{name|{b}}\n{count|${item.total_num}万}\n`,
                        labelLine: {
                            length: 20,
                        },

                        rich: {
                            count: {
                                fontSize: 12,
                                color: "rgba(0, 0, 0, 0.45)",
                                padding: [0, 0, 0, 11],
                            },
                            name: {
                                padding: [0, 0, 0, 5],
                                fontSize: 12,
                                color: "rgba(0, 0, 0, 0.65)",
                            },
                            circle: {
                                width: 6,
                                height: 6,
                                backgroundColor: color[index],
                                borderRadius: 5,
                                color: "rgba(255,255,255,0)",
                            },
                        },
                    },
                };
                const s_item2 = {
                    name: item.type_title,
                    value: item.total_num,
                    color: color[index],
                    rate: item.rate,
                    label: {
                        normal: {
                            show: true,
                            position: "inner", // 数值显示在内部
                            formatter: "{d}%",
                            color: "#ffffff",
                        },
                    },
                };
                sData.push(s_item);
                sData2.push(s_item2);
            });
            this.getEchartsPie("container2", sData, sData2, color);
        },
        getEchartsPie(id, sData, sData2, color) {
            var dom = document.getElementById(id);
            var myChart = echarts.init(dom);
            myChart.clear();
            var option;
            var that = this;
            option = {
                color,
                title: {
                    text: "",
                },
                tooltip: {
                    trigger: "item",
                    backgroundColor: "#fffffff",
                    padding: 12,
                    formatter: function (params) {
                        let html = "";
                        html += `<div class="custom_chart_tooltip"><p class="tooltip_title"><span>${params.name}</span></p><p class="tooltip_content"><span class="chart_circle_item"><i class="chart_circle" style="background: ${params.color}"></i>${params.value}万</span><span class="count">${params.percent}%</span></p></div>`;
                        return html;
                    },
                },
                legend: {
                    show: false,
                    icon: "rect",
                    itemWidth: 10,
                    itemHeight: 8,
                    borderRadius: 2,
                    textStyle: {
                        fontSize: 14, // 设置图例文本的字体大小为 16 像素
                        padding: [5, 0, 5, 0],
                    },
                    left: 0,
                    itemGap: 10,
                    top: 0,
                },
                left: "center",
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
                series: [
                    {
                        name: "",
                        type: "pie",
                        avoidLabelOverlap: true,
                        radius: 90,
                        top: 0,
                        labelLine: {
                            length: 25,
                            length2: 60,
                            maxSurfaceAngle: 80,
                            showAbove: true,
                            lineStyle: {
                                color: "rgba(0, 0, 0, 0.25)",
                            },
                        },
                        labelLayout: function (params) {
                            const isLeft = params.labelRect.x < myChart.getWidth() / 2;
                            const points = params.labelLinePoints;
                            // Update the end point.
                            points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params.labelRect.width;
                            return {
                                labelLinePoints: points,
                            };
                        },
                        data: sData,
                    },
                    {
                        name: "",
                        type: "pie",
                        avoidLabelOverlap: true,
                        radius: 90,
                        top: 0,
                        data: sData2,
                    },
                ],
            };
            option && myChart.setOption(option, true);
            this.myChartPie = myChart;
            this.handleResizePie();
            window.addEventListener("resize", this.handleResizePie);
        },
        handleResize() {
            if (this.resizeHandler) {
                clearTimeout(this.resizeHandler);
            }
            this.resizeHandler = setTimeout(() => {
                if (this.myChartBar) {
                    this.myChartBar.resize();
                }
            }, 100);
        },
        handleResizePie() {
            if (this.resizeHandlerPie) {
                clearTimeout(this.resizeHandlerPie);
            }
            this.resizeHandlerPie = setTimeout(() => {
                if (this.myChartPie) {
                    this.myChartPie.resize();
                }
            }, 100);
        },
        handleClickDetail(row) {
            this.customer_id = row.customer_id;
            this.payment_company_name = row.payment_company_name;
            this.supplier_name = row.supplier_name;
            this.detailDialogVisible = true;
            this.getDetailInfo();
        },
        // 明细弹框
        handleDialogClose() {
            this.detailDialogVisible = false;
            this.detailTableData = [];
        },
        // 获取明细详情
        getDetailInfo() {
            let params = {
                page: 1,
                pageSize: 1000,
            };
            if (this.tabActiveName == "badDebt" || this.tabActiveName == "unRefund") {
                params.customer_id = this.customer_id;
            } else if (this.tabActiveName == "orderRefund") {
                params.payment_company_name = this.payment_company_name;
            } else if (this.tabActiveName == "purchase") {
                params.supplier_name = this.supplier_name;
            }
            if (this.tabActiveName == "badDebt") {
                BadDebtCustomerDetail(params).then((res) => {
                    if (res.code === 200) {
                        const { data, total } = res.data;
                        this.detailTableData = data || [];
                    }
                });
            } else if (this.tabActiveName == "unRefund") {
                UnpaidCustomerOrders(params).then((res) => {
                    if (res.code === 200) {
                        const { data, total } = res.data;
                        this.detailTableData = data || [];
                    }
                });
            } else if (this.tabActiveName == "orderRefund") {
                RepayCompanyDetail(params).then((res) => {
                    if (res.code === 200) {
                        const { data, total } = res.data;
                        this.detailTableData = data || [];
                    }
                });
            } else if (this.tabActiveName == "purchase") {
                PurchaseRefundDetailList(params).then((res) => {
                    if (res.code === 200) {
                        const { data, total } = res.data;
                        this.detailTableData = data || [];
                    }
                });
            } else {
                if (this.customer_id) {
                    // params.customer_id = this.customer_id;
                    ReceivableOrderSummaryDetail({ customer_id: this.customer_id }).then((res) => {
                        if (res.code === 200) {
                            this.detailTableData = res.data || [];
                        }
                    });
                } else {
                    params.supplier_name = this.supplier_name;
                    ReceivablePurchaseRefundSummaryDetail(params).then((res) => {
                        if (res.code === 200) {
                            const { data, total } = res.data;
                            this.detailTableData = res.data || [];
                        }
                    });
                }
            }
        },
        // 查看客户详情
        handleClickCustomerDetail(customer_id, customer_name) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id,
                    name: customer_name,
                },
            });
        },
        // 订单详情
        handleClickOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.order_num,
                    name: row.order_num,
                    query_type: "order_no",
                },
            });
        },
        // 应收详情
        handleClickReceivableDetail(row) {
            this.receivable_no = row.receivable_no;
            this.receivableDetailsVisible = true;
        },
        // 审批详情
        handleClickApprovalDetail(approval_id) {
            this.$showApprovalDetail({
                approval_id,
            }).then((res) => {});
        },
        // 采购详情
        handleClickRelateId(purchaseId) {
            this.purchaseId = purchaseId;
            this.purchaseDetailVisible = true;
        },
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
        if (this.myChartBar) {
            this.myChartBar.dispose();
        }
        if (this.myChartPie) {
            this.myChartPie.dispose();
        }
    },
};
</script>
<style lang="scss" scoped>
.payable_statistics_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .el-tabs {
        ::v-deep {
            .el-tabs__nav {
                margin: 0 16px;
            }

            .el-tabs__header {
                margin: 0;
            }

            .el-tabs__item {
                padding: 0 16px !important;
                height: 48px;
                line-height: 48px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);

                &.is-active {
                    font-weight: 700;
                    color: rgba(41, 144, 255, 1);
                }
            }
        }
    }

    .content_right_wrap {
        flex: 1;
        padding: 16px;
        overflow-y: auto;
    }

    .static_num_top {
        margin-top: 16px;
        display: flex;
        flex-wrap: wrap;
        gap: 16px;

        li {
            min-width: 264px;
            // max-width: calc(100% / 4);
            flex: 1;
            height: 108px;
            border-radius: 8px;
            background-color: rgba(255, 255, 255, 1);
            background-image: url("https://download.hecoos.com/enlightv/2025-00/ee27b3034b8636b993102080c3e1967d.png");
            background-repeat: no-repeat;
            background-size: 103px 103px;
            background-position: calc(100% + 28px) 35px;
            box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);

            p:nth-child(1) {
                height: 44px;
                border-radius: 6px 6px, 0px, 0px;
                background: rgba(41, 144, 255, 0.07);
                text-align: center;
                line-height: 44px;
                font-size: 16px;
                font-weight: 700;
                letter-spacing: 0px;
                color: rgba(102, 102, 102, 1);
            }

            p:nth-child(2) {
                text-align: center;
                line-height: 64px;
                font-size: 22px;
                font-weight: 700;
                letter-spacing: 0px;
                color: rgba(41, 144, 255, 1);
            }
        }
    }

    .chart_box {
        margin: 16px 0;
        width: 100%;
        height: 336px;
        display: flex;
        flex-wrap: nowrap;
        gap: 15px;
        .chart_item_box {
            height: 100%;
            padding: 10px 16px 0;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
            .chart_box_title {
                display: flex;
                height: 28px;
                align-items: center;
                justify-content: space-between;

                & > span {
                    font-size: 16px;
                    font-weight: 500;
                    letter-spacing: -0.2px;
                    line-height: 16px;
                    color: rgba(51, 51, 51, 0.85);
                }

                .chart_box_title_right {
                    display: flex;
                    gap: 12px;

                    span {
                        width: 64px;
                        height: 28px;
                        opacity: 1;
                        text-align: center;
                        line-height: 28px;
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        color: rgba(102, 102, 102, 1);
                        background: rgba(243, 243, 243, 1);
                        border-radius: 12px;
                        cursor: pointer;

                        &.active {
                            color: rgba(41, 144, 255, 1);
                            background: rgba(41, 144, 255, 0.16);
                        }
                    }
                }
            }

            .chart_box_bottom {
                width: 100%;
                margin-top: 10px;
                height: calc(100% - 48px);
                display: flex;
                gap: 15px;

                .echarts_container {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .chart_item_box_bar {
            flex: 1;
        }
        .chart_item_box_flex {
            width: calc(61.48% - 15px);
        }
        .chart_item_box_pie {
            flex-shrink: 0;
            width: 38.52%;
        }
    }
}
</style>
<style lang="scss">
.custom_chart_tooltip {
    background-color: #ffffff;
    padding: 12px;
    border-radius: 2px;
    box-shadow: 0px 2px 4px #0000003f;
    .tooltip_title {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: -0.2px;
        line-height: 12px;
        color: rgba(0, 0, 0, 0.45);
    }
    .tooltip_content {
        margin-top: 12px;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: -0.2px;
        line-height: 12px;
        color: rgba(0, 0, 0, 0.65);
        display: flex;
        justify-content: space-between;
        gap: 24px;
        .count {
            font-weight: 500;
        }
        .chart_circle_item {
            display: flex;
            align-items: center;
            .chart_circle {
                display: inline-block;
                vertical-align: middle;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                margin-right: 9px;
            }
        }
    }
}
</style>
